import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITourType, ITourTypeInitialState } from "./tourtypeModal";
import {
  ActiveInactiveTourType,
  createTourType,
  deleteTourType,
  TourTypeImageUpload,
  getAllActiveTourType,
  getAllTourType,
  getTourTypeByID,
  updateTourType,
} from "./services/tourtype.service";

const initialState: ITourTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  TourTypeID: null,
  TourTypeList: [],
  TourTypeDetail: {
    ID: null,
    Title: "",
    TourType: "",
    Description: "",
    Image: "",
    IsActive: 1,
  },
};

const tourtypeSlice = createSlice({
  name: "tourtype",
  initialState,
  reducers: {
    clearTourTypeDetails: (state) => {
      state.TourTypeDetail = initialState.TourTypeDetail;
    },
    setTourTypeID: (state, action) => {
      state.TourTypeID = action.payload;
    },
    clearTourTypeID: (state) => {
      state.TourTypeID = initialState.TourTypeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTourType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTourType.fulfilled,
      (state, action: PayloadAction<ITourType[]>) => {
        state.loading = false;
        state.TourTypeList = action.payload || [];
      },
    );
    builder.addCase(getAllTourType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TourTypeList = [];
    });
    builder.addCase(createTourType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createTourType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTourType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTourType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTourType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTourType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTourType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTourType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTourType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTourTypeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTourTypeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TourTypeDetail = action.payload;
    });
    builder.addCase(getTourTypeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TourTypeDetail = initialState.TourTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTourType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTourType.fulfilled,
      (state, action: PayloadAction<ITourType[]>) => {
        state.loading = false;
        state.TourTypeList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveTourType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TourTypeList = [];
    });
    builder.addCase(ActiveInactiveTourType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTourType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTourType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(TourTypeImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(TourTypeImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(TourTypeImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearTourTypeDetails, clearTourTypeID, setTourTypeID } =
  tourtypeSlice.actions;
export default tourtypeSlice.reducer;
